import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';

/** Ein Wechsel von Apartment, Monat oder Bereich verwirft Eingaben im Editor nie ohne Bestätigung. */
export function DiscardChangesDialog({
  open,
  onDiscard,
  onKeep,
}: {
  open: boolean;
  onDiscard: () => void;
  onKeep: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onKeep()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Eingaben verwerfen?</DialogTitle>
          <DialogDescription>
            Im Editor stehen Werte, die noch nicht gesendet wurden. Beim Wechsel gehen sie verloren.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={onKeep}>
            Weiter bearbeiten
          </Button>
          <Button type="button" variant="destructive" onClick={onDiscard}>
            Verwerfen und wechseln
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
